// Offices that are not stored in the admin-managed site settings (which only holds the US address).
export const UK_OFFICE = {
  label: "UK Office",
  company: "MS Technologies and Financials Ltd",
  address: "167-169 Great Portland Street, 5th Floor, London, England, W1W 5PF",
};

export const mapsUrl = (address) =>
  `https://maps.google.com/?q=${encodeURIComponent(address)}`;
